import { Card, CardBody, Container } from "reactstrap";

interface Props {
    groupName: string;
}

const steps = (groupName: string) => [
    {
        title: "Join the Buying Group",
        description: `Register your interest in purchasing ${groupName} `,
    },
    {
        title: "Grow the Group",
        description:
            "More buyers join, increasing the group's collective bargaining power.",
    },
    {
        title: "Collect Offers",
        description:
            "Group members and the PriceWorth coordinator gather quotations and special offers from multiple sellers or service providers.",
    },
    {
        title: "Compare & Discuss",
        description:
            "Review prices, features, quality, warranties, service, delivery schedules, financing options, and other important factors together.",
    },
    {
        title: "Negotiate the Best Deal",
        description:
            "The group negotiates collectively to secure the most attractive pricing and benefits.",
    },
    {
        title: "Choose What Works for You",
        description:
            "Group members are free to choose the seller, service provider, or offer that best suits their needs.",
    },
    {
        title: "Complete Your Purchase",
        description:
            "Purchase directly from your preferred seller using the negotiated group offer.",
    },
];

const ProductHowItWorks = ({ groupName }: Props) => {
    return (
        <Container className="py-5" style={{ maxWidth: "900px" }}>
            <div className="text-center mb-5">
                <h2 className="fw-bold">How It Works</h2>
                <p className="text-muted">
                    A simple step-by-step process to help every student secure the best
                    coaching institute at the best possible price.
                </p>
            </div>

            {steps(groupName).map((step, index) => (
                <div className="d-flex mb-4" key={index}>
                    {/* Left Timeline */}
                    <div
                        className="d-flex flex-column align-items-center me-4"
                        style={{ minWidth: "50px" }}
                    >
                        <div
                            className="rounded-circle bg-primary text-white fw-bold d-flex justify-content-center align-items-center"
                            style={{
                                width: "42px",
                                height: "42px",
                                fontSize: "16px",
                            }}
                        >
                            {index + 1}
                        </div>

                        {index !== steps(groupName).length - 1 && (
                            <div
                                style={{
                                    width: "2px",
                                    flex: 1,
                                    background: "#dee2e6",
                                    minHeight: "55px",
                                }}
                            />
                        )}
                    </div>

                    {/* Content */}
                    <Card className="border-0 shadow-sm rounded-4 flex-grow-1">
                        <CardBody>
                            <h5 className="fw-bold mb-2">{step.title}</h5>
                            <p className="text-muted mb-0" style={{ lineHeight: "1.7" }}>
                                {step.description}
                            </p>
                        </CardBody>
                    </Card>
                </div>
            ))}
        </Container>
    );
};

export default ProductHowItWorks;